import React, { useRef, useEffect, useState } from "react";
import { fabric } from "fabric";
import { CanvasContext } from "./CanvasContext";

export const CanvasProvider = ({ children }) => {
  const canvasRef = useRef(null);
  const [canvas, setCanvas] = useState(null);

  useEffect(() => {
    if (canvasRef.current) {
      const canvas = new fabric.Canvas(canvasRef.current, {
        hoverCursor: "pointer",
        selection: true,
        selectionBorderColor: "blue",
        isDrawingMode: false,
        backgroundColor: "white",
        fireRightClick: true,
        stopContextMenu: true,
      });
      canvas.setWidth(355);
      canvas.setHeight(460);
      setCanvas(canvas);

      // Touch event listener to focus on the canvas
      canvasRef.current.addEventListener("touchstart", () => {
        canvasRef.current.style.touchAction = "none"; // Disable touch actions
        canvasRef.current.focus(); // Focus on the canvas
      });
    }
  }, [canvasRef]);

  const scaleObject = (object, scaleX, scaleY) => {
    object.scaleX = 0.5;
    object.scaleY = 0.5;
    canvas.renderAll(); // Render the canvas to see the updated object
  };

  return (
    <CanvasContext.Provider value={{ canvas, canvasRef, scaleObject }}>
      {console.log("Provided canvas: >>>>>>>   >>>>>>   ", canvas)}{" "}
      {/* Log the provided canvas */}
      {children}
    </CanvasContext.Provider>
  );
};
